<template>
  <div class="input-cell-edit" @click.stop="switchEdit">
    <span v-show="!isEdit">{{ data || '-' }}</span>
    <div class="edit" v-show="isEdit">
      <PgInput
        class="edit-input"
        ref="inputRef"
        v-bind="$attrs"
        :value="data"
        v-on="event"
        @input="onInput"
        @blur="onBlur"
      ></PgInput>
      <template v-if="!focus">
        <el-button size="mini" round @click.stop="onCancel">取消</el-button>
        <el-button type="primary" size="mini" round :disabled="isDisabled" @click.stop="onSave">
          保存
        </el-button>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
}
</script>
<script setup>
import { useListeners, computed, ref } from 'vue'
import { useInputCellEdit } from '../hooks/index'
import { PgInput } from '../../input/index'

const props = defineProps({
  value: [String, Number],
  row: Object,
  conCode: String,
  saveUrl: String,
  saveUrlParams: Object,
  delUrl: String,
  delUrlParams: Object,
  valueToSaveUrlParamKey: String,
  formDataUrl: String,
  formDataParam: Object,
  targetComponent: String, // 指定父组件的组件名，例如：crudDoubleQuery
  reload: Boolean, // 保存后是否刷新，配合 targetComponent 找到指定的父组件，使用父组件的方法 reload() 刷新
  focus: Boolean,
})

const data = ref(props.value)

const { isEdit, isDisabled, inputRef, switchEdit, onSave, onCancel, onInput, onBlur } =
  useInputCellEdit({
    data,
    props,
  })

const listeners = useListeners()
const excludes = ['input', 'blur']
const event = computed(() =>
  Object.keys(listeners).reduce((pre, cur) => {
    if (!excludes.includes(cur)) pre[cur] = listeners[cur]
    return pre
  }, {})
)
</script>
<style lang="scss">
@import '../style/input-cell-edit.scss';
</style>
